import { create } from "zustand";
import { SAVED_POSTS } from "../constants/localStorageKeys";
import { retrieve, save } from "../helpers/StorageHelper";

// Hydrate initial saved posts synchronously from localStorage
const initialSavedPosts = retrieve(SAVED_POSTS) ?? [];

const persist = (posts) => {
  try {
    save(SAVED_POSTS, posts);
  } catch {}
};

const useSavedPostsStore = create((set, get) => ({
  savedPosts: initialSavedPosts,

  toggleSavePost: (post) => {
    const current = get().savedPosts;
    const exists = current.find((p) => p.id === post.id);
    const next = exists
      ? current.filter((p) => p.id !== post.id)
      : [...current, post];
    persist(next);
    set({ savedPosts: next });
    return next;
  },
}));

export default useSavedPostsStore;
